import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import printlogo from '../../printpropertise/printlogoceylonika.png';

const pdfStyles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontSize: 9,
    fontFamily: 'Helvetica',
  },
  headerSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#cccccc',
    paddingBottom: 10,
  },
  companyDetails: {
    flexDirection: 'column',
  },
  logo: {
    width: 150,
    height: 45,
    marginBottom: 5,
  },
  companyName: {
    fontSize: 11,
    fontFamily: 'Helvetica-Bold',
  },
  companyAddress: {
    fontSize: 9,
    maxWidth: 250,
  },
  reportInfo: {
    textAlign: 'right',
  },
  reportTitle: {
    fontSize: 14,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 5,
  },
  reportDate: {
    fontSize: 9,
    marginBottom: 2,
  },
  reportTime: {
    fontSize: 9,
    marginBottom: 2,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    borderStyle: "solid",
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#e0e0e0',
    padding: 5,
    textAlign: 'center',
    fontFamily: 'Helvetica-Bold',
  },
  tableCol: {
    borderStyle: "solid",
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    justifyContent: 'center',
  },
  tableCellHeader: {
    margin: "auto",
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
  },
  tableCell: {
    fontSize: 8,
    paddingHorizontal: 2,
    paddingVertical: 2,
    overflow: 'hidden',
    textAlign: 'left',
  },
  tableCellRight: {
    fontSize: 8,
    paddingHorizontal: 2,
    paddingVertical: 2,
    overflow: 'hidden',
    textAlign: 'right',
    width: '100%',
  },
  summaryBox: {
    borderRadius: 5,
    backgroundColor: '#edfcfc',
    padding: 10,
    marginTop: 10,
    alignSelf: 'flex-end',
    width: '40%',
  },
  summaryHeader: {
    backgroundColor: '#a0fae8',
    padding: 5,
    borderRadius: 5,
    marginBottom: 8,
    fontFamily: 'Helvetica-Bold',
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 2,
  },
  summaryLabel: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
  },
  summaryValue: {
    fontSize: 9,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 35,
    right: 35,
    textAlign: 'center',
    color: 'grey',
    fontSize: 8,
  },
});

export const TellerSummaryPDF = ({data, tellername,filterdate,transactiontype }) => {
  const totalOrderCost = data.reduce((sum, item) => sum + (item.transactionAmount || 0), 0);

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page} orientation="portrait">
        {/* Header */}
        <View style={pdfStyles.headerSection} fixed>
          <View style={pdfStyles.companyDetails}>
            <Image src={printlogo} style={pdfStyles.logo} />
            <Text style={pdfStyles.companyName}>Ceylonika Cosmetics (Pvt) Ltd</Text>
            <Text style={pdfStyles.companyAddress}>154/11, Pushparama Road, Kadawatha</Text>
            <Text style={pdfStyles.companyAddress}>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
            <Text style={pdfStyles.companyAddress}>+94 112 92 44 20</Text>
          </View>
          <View style={pdfStyles.reportInfo}>
            <Text style={pdfStyles.reportTitle}>Teller Daily Transactions Report</Text>
            <Text style={pdfStyles.reportDate}>Teller : {tellername}</Text>
            <Text style={pdfStyles.reportDate}>Target Date : {filterdate}</Text>
            <Text style={pdfStyles.reportDate}>Paid Type : {transactiontype}</Text>
            <Text style={pdfStyles.reportTime}>Print Date/Time: {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}</Text>
          </View>
        </View>

        {/* Table Header */}
        <View style={pdfStyles.table}>
          <View style={[pdfStyles.tableRow, { backgroundColor: '#d0d0d0',textAlign:'center' }]} fixed>
            {[
              { label: "Order No", width: '10%' },
              { label: "Order Status", width: '15%' },
              { label: "Order Total", width: '10%' },
              { label: "Paid Type", width: '10%' },
              { label: "Paid Amount", width: '10%' },
              { label: "Payment Details", width: '30%' },
              { label: "Paid Date/Time", width: '15%' }
            ].map(col => (
              <View key={col.label} style={[pdfStyles.tableColHeader, { width: col.width }]}>
                <Text style={pdfStyles.tableCellHeader}>{col.label}</Text>
              </View>
            ))}
          </View>

          {/* Table Rows */}
          {data.map((item, idx) => (
            <View style={pdfStyles.tableRow} key={item.id || idx} wrap={false}>
              <View style={[pdfStyles.tableCol, { width: '10%' }]}><Text style={pdfStyles.tableCell}>{item.invoiceNo}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '15%' }]}><Text style={pdfStyles.tableCell}>{item.invoiceStatus}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '10%' }]}><Text style={pdfStyles.tableCellRight}>{item.orderCost?.toFixed(2)}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '10%' }]}><Text style={pdfStyles.tableCell}>{item.transactionType}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '10%' }]}><Text style={pdfStyles.tableCell}>{item.transactionAmount}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '30%' }]}><Text style={pdfStyles.tableCell}>{item.transactionDetail}</Text></View>
              <View style={[pdfStyles.tableCol, { width: '15%' }]}><Text style={pdfStyles.tableCell}>{item.transactionTime}</Text></View>              
            </View>
          ))}
        </View>

        {/* Final Summary */}
        <View style={pdfStyles.summaryBox}>
          <Text style={pdfStyles.summaryHeader}>Summary</Text>
          <View style={pdfStyles.summaryRow}>
            <Text style={pdfStyles.summaryLabel}>Total Orders:</Text>
            <Text style={pdfStyles.summaryValue}>{data.length}</Text>
          </View>
          <View style={pdfStyles.summaryRow}>
            <Text style={pdfStyles.summaryLabel}>Total Paid Amount:</Text>
            <Text style={pdfStyles.summaryValue}>
              {totalOrderCost.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <Text style={pdfStyles.footer} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} fixed />
      </Page>
    </Document>
  );
};

export default TellerSummaryPDF;